import React, { useState, useRef, useEffect } from "react";
import styles from "./dropdown.module.scss";
import clsx from "clsx";

const Dropdown = ({
  label,
  options,
  selected,
  setSelected,
  dropdownKey,
  placeholderText = "",
  additionalClass = "",
  setIsUserInteraction = () => {},
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleSelect = (key, value) => {
    setSelected(key, value);
    setIsOpen(false);
    if (setIsUserInteraction) {
      setIsUserInteraction(true);
    }
  };

  return (
    <div className={styles.dropdown} ref={dropdownRef}>
      {label && <div className={styles.dropdownLabel}>{label}</div>}
      <div
        className={clsx(
          !additionalClass && styles.dropdownHeader,
          additionalClass
        )}
        onClick={toggleDropdown}
      >
        {selected ? selected.label : placeholderText}{" "}
        {/* Display selected label */}
        <div
          className={clsx(styles.dropdownArrow, isOpen && styles.open)}
        ></div>
      </div>
      {isOpen && (
        <ul className={clsx(styles.dropdownList, styles.dropdownListOpen)}>
          {options?.map((option) => (
            <li
              key={option.value}
              className={clsx(
                styles.dropdownItem,
                option?.value === selected?.value ? styles.activeItem : ""
              )}
              onClick={() => handleSelect(dropdownKey, option.value)}
            >
              {option?.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
